import React from 'react';
import { useT } from '../i18n/LanguageContext';

export default function PageHeader({ title, subtitle, children, headingRef }) {
  // A page passes its English title/subtitle as before; the lookup happens here so callers need
  // not change. Already-translated text (or a React element) passes through t() untouched.
  const t = useT();
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap mb-6">
      <div className="min-w-0">
        <h1
          ref={headingRef}
          tabIndex={headingRef ? -1 : undefined}
          className="text-[28px] font-bold text-[#0f172a] leading-snug"
        >
          {t(title)}
        </h1>
        {subtitle && <p className="text-[15px] text-[#64748b] mt-1">{t(subtitle)}</p>}
      </div>
      {children && <div className="flex items-center gap-3 flex-wrap">{children}</div>}
    </div>
  );
}
